"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const base_measure_component_1 = require("../base_measure.component");
const material_1 = require("@angular/material");
const measurement_helper_service_1 = require("../../../../../service/measurement-helper.service");
const entity_helper_service_1 = require("../../../../../service/entity-helper.service");
const router_1 = require("@angular/router");
const map_component_1 = require("../../../map.component");
const map_service_1 = require("../../../../../commons/map.service");
const application_events_service_1 = require("../../../../../xs/services/events/application-events.service");
const epsg_helper_service_1 = require("../../../../../service/epsg-helper.service");
const file_manager_service_1 = require("@src/app/service/file-manager.service");
class MultiPoiComponent extends base_measure_component_1.BaseMeasure {
    constructor(route, router, snackBar, dialog, mapComp, mapService, mappingHelper, entityHelper, applicationEvents, epsgHelper, fileManager) {
        super(route, router, snackBar, dialog, mapComp, mapService, mappingHelper, entityHelper, applicationEvents, epsgHelper, fileManager);
        this.route = route;
        this.router = router;
        this.mapComp = mapComp;
        this.mapService = mapService;
        this.mappingHelper = mappingHelper;
        this.entityHelper = entityHelper;
        this.applicationEvents = applicationEvents;
        this.epsgHelper = epsgHelper;
        this.fileManager = fileManager;
    }
    ngOnInit() {
        // because of local coordinates the sequence of loading scene is changed so once scene is ready we process
        if (this.mapService.scene) {
            super.onInit();
        }
        else {
            this.addSubscription('multiPoi-sceneChange', this.mapService.onSceneChange('multi-poi.component').subscribe(_ => {
                super.onInit();
            }));
        }
    }
    ngOnDestroy() {
        super.onDestroy();
    }
}
exports.MultiPoiComponent = MultiPoiComponent;
